<div *ngIf="siteDevices.length && !isStudyDevice">
	<div class="row mx-3">
		<div class="d-flex align-items-center">
			<div class="device-details-split mx-3"></div>
			<div *ngIf="device.config_info?.ip_address" class="device-details">
				<div class="font-weight-bold">
					{{'devices.public_ip' | translate}}
				</div>
				<div>
					{{device.config_info.ip_address}}
				</div>
			</div>
			<div *ngIf="device.config_info?.ip_address" class="device-details-split mx-3"></div>
			<div *ngIf="isTabletOrMobile">
				<div class="search-container d-flex flex-column">
					<div class="devices-list">
						<ng-select
							[items]="siteDevices"
							[searchable]="!commonService.isTabletOrMobileScreen"
							bindLabel="prettyName"
							bindValue="mac_address"
							placeholder="{{'devices.select_device' | translate}}"
							name="deviceID"
							class="multi-line-options"
							[(ngModel)]="deviceID"
							[clearable]="false"
							(ngModelChange)="deviceChanged()"
						></ng-select>
					</div>
					<div *ngIf="deviceLastConnectTime" class="device-details-split-horizontal"></div>
					<div *ngIf="deviceLastConnectTime" class="device-details">
						<div class="font-weight-bold">
							{{'devices.last_connect_time' | translate}} ({{showUserTimeZoneReference()}})
						</div>
						<div>
							{{getDeviceLastConnectTime}}
						</div>
					</div>
			</div>
			</div>

			<button #hiddenPrintBtn style="display: none" *ngIf="deviceConfig?.performance?.hasBatteryReport" ngxPrint [useExistingCss]="true" printSectionId="batterySummaryReport" [printTitle]="'Battery Summary Report - ' + device.mac_address"></button>
			<button
				*ngIf="deviceConfig?.performance?.hasBatteryReport && isPerformanceActive"
				class="btn fa fa-print fa-lg print-btn"
				(click)="openPrintModal()"
				title="{{'g.print' | translate}}">
			</button>

			<div *ngIf="deviceConfig?.performance?.hasBatteryReport && isPerformanceActive" class="device-details-split mx-3"></div>

			<button #hiddenPrintBtn style="display: none" *ngIf="deviceConfig?.performance?.hasTruckReport" ngxPrint [useExistingCss]="true" printSectionId="truckSummaryReport" [printTitle]="'Truck Summary Report - ' + device.mac_address"></button>
			<button
				*ngIf="deviceConfig?.performance?.hasTruckReport && isPerformanceActive"
				class="btn fa fa-print fa-lg print-btn"
				(click)="openPrintModal()"
				title="{{'g.print' | translate}}">
			</button>

			<div *ngIf="deviceConfig?.performance?.hasTruckReport && isPerformanceActive" class="device-details-split mx-3"></div>

			<button
				*ngIf="(deviceConfig?.isCharglink || deviceConfig?.isBrm) && isPerformanceActive"
				class="btn fa fa-print fa-lg print-btn"
				(click)="triggerCharglinkPrint()"
				title="{{'g.print' | translate}}">
			</button>

			<div *ngIf="(deviceConfig?.isCharglink || deviceConfig?.isBrm) && isPerformanceActive" class="device-details-split mx-3"></div>

			<div *ngIf="deviceLastConnectTime && !isTabletOrMobile" class="device-details">
				<div class="font-weight-bold">
					{{'devices.last_connect_time' | translate}} ({{showUserTimeZoneReference()}})
				</div>
				<div>
					{{getDeviceLastConnectTime}}
				</div>
			</div>
			<div *ngIf="deviceLastConnectTime && !isTabletOrMobile" class="device-details-split mx-3"></div>
			<div class="devices-list" *ngIf="!isTabletOrMobile">
				<ng-select
					[items]="siteDevices"
					bindLabel="prettyName"
					bindValue="mac_address"
					placeholder="{{'devices.select_device' | translate}}"
					name="deviceID"
					class="multi-line-options"
					[(ngModel)]="deviceID"
					[clearable]="false"
					(ngModelChange)="deviceChanged()"
				></ng-select>
			</div>
			<app-device-actions
				[device]="device"
				[changesStack]="changesStack"
				[simInfo]="simInfo"
				[enterprisePermissions]="enterprisePermissions"
				(changePage)="goToPage($event)"
				(refreshDevice)="refreshDevice()"
				*ngIf="!multiDevices"
			></app-device-actions>
		</div>
	</div>
</div>

<app-modal #printModal *ngIf="deviceConfig?.performance?.hasBatteryReport" title="{{ 'g.select_period_to_print' | translate }}" [hasCloseButton]="false" [hasConfirmButton]="false">
	<div class="p-3">
		<ng-select
			class="select"
			[items]="periods"
			[addTag]="false"
			[clearable]="false"
			[searchable]="false"
			bindLabel="label"
			bindValue="value"
			(change)="onPeriodChanged($event.value)"
			[placeholder]="'g.durations' | translate"
			[(ngModel)]="printSelectedPeriod"
		></ng-select>
		<div class="mt-3 text-end">
			<button class="btn btn-primary" (click)="confirmPrint()">Print</button>
		</div>
	</div>
</app-modal>

<app-modal #printModal *ngIf="deviceConfig?.performance?.hasTruckReport" title="{{ 'g.print_truck_summary_report' | translate }}" [hasCloseButton]="false" [hasConfirmButton]="false">
	<div class="p-3">
		<label for="periodSelect">{{"rt_history.periods" | translate}}</label>
		<ng-select
			class="select"
			[items]="periods"
			[addTag]="false"
			[clearable]="false"
			[searchable]="false"
			bindLabel="label"
			bindValue="value"
			(change)="onSelectionReportChanged({filter: 'period', value: $event.value})"
			[placeholder]="'g.durations' | translate"
			[(ngModel)]="printSelectedPeriod"
		></ng-select>
		<label class="mt-3" for="workingDaysSelect">{{"operation_analysis.working_days" | translate}}</label>
		<ng-select
			class="select"
			[items]="daysFilters"
			[addTag]="false"
			[clearable]="false"
			[searchable]="false"
			bindLabel="label"
			bindValue="value"
			(change)="onSelectionReportChanged({filter: 'daysFilter', value: $event.value})"
			[placeholder]="'g.durations' | translate"
			[(ngModel)]="selectedReportDaysFilter"
		></ng-select>
		<div class="mt-3 text-end">
			<button class="btn btn-primary" (click)="confirmPrintTruck()">Print</button>
		</div>
	</div>
</app-modal>